import React from "react";

const LOGO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_a1364184-ae99-49c2-8a82-7dff3f89376c/artifacts/04wpa38p_IMG_6107.PNG";

export const Logo = ({ className = "h-10 w-10", showWordmark = false, invert = false }) => (
  <div className="flex items-center gap-3" data-testid="autobahn-logo">
    <img
      src={LOGO_URL}
      alt="Autobahn Cars"
      className={className}
      style={{ objectFit: "contain" }}
    />
    {showWordmark && (
      <div className={`leading-none ${invert ? "text-white" : "text-[#111111]"}`}>
        <div className="font-display font-bold tracking-tighter text-xl">autobahn</div>
        <div className="overline mt-1 text-[9px] tracking-[0.3em]" style={{ color: invert ? "rgba(255,255,255,0.6)" : "#7A1519" }}>
          Cars &amp; Wheels
        </div>
      </div>
    )}
  </div>
);

export default Logo;
